import { Navigate } from 'react-router';

import { isActCourse, isDatCourse, isLsatCourse, isMcatCourse, isSatCourse } from 'my-core/course-utils';
import { useCurrentUser } from 'my-core/hooks';
import {
  studentActDashboardPath,
  studentDashboardPath,
  studentDatDashboardPath,
  studentLsatDashboardPath,
  studentMcatDashboardPath,
  studentSatDashboardPath,
} from 'my-core/routes';
import { useCurrentUserSubscription } from 'my-core/subscription-utils';

let cachedPath = null;
export function setCachedDashboardPath(path) {
  cachedPath = path;
}

const MATCHERS = [
  [isLsatCourse, studentLsatDashboardPath],
  [isDatCourse, studentDatDashboardPath],
  [isSatCourse, studentSatDashboardPath],
  [isActCourse, studentActDashboardPath],
];

export default function StudentDashboardRedirect() {
  const currentUser = useCurrentUser({ includeCourses: true });
  const subscription = useCurrentUserSubscription();

  function getDefaultStudentPath() {
    if (cachedPath) return cachedPath;

    const isPreMedStudent = currentUser.user_courses.some(
      uc =>
        subscription?.is_premed_plus || (isMcatCourse(uc.course) && (uc.status === 'active' || uc.course_schedule_id)),
    );
    if (isPreMedStudent) return studentMcatDashboardPath();

    for (const uc of currentUser.user_courses) {
      for (const [isCourseFn, locationFn] of MATCHERS) {
        if (isCourseFn(uc.course) && (uc.status === 'active' || uc.course_schedule_id)) {
          return locationFn();
        }
      }
    }
    return studentDashboardPath();
  }
  return <Navigate replace to={getDefaultStudentPath()} />;
}
